module.exports = __webpack_public_path__ + "static/media/organic-chemistry.5d886706.svg";